import { ref } from "vue";
import { getDirectoryItem } from "../api";

export function useParticipantTypes() {
  const participantTypes = ref([]);

  async function fetchParticipantTypes() {
    try {
      const { success, payload } = await getDirectoryItem("participants");
      if (success && payload) {
        participantTypes.value = payload?.children || [];
      }
    } catch (e) {
      console.error("fetchParticipantTypes error:", e);
    }
  }

  function getReferenceTitle(code) {
    if (!code) return "";
    return (
      participantTypes.value.find((item) => item.code === code)?.name || code
    );
  }

  return { participantTypes, fetchParticipantTypes, getReferenceTitle };
}
